/* eslint-disable @typescript-eslint/no-namespace */
// ^ allowing namespaces reduces collisions for these names
import { UserProductsAuthorizations } from "services/apiClient/shellApiClient";

import type { TranslationKey } from "../i18n";

import model from "./model.json";

const menuModel = model as Array<MenuLink.All>;

export namespace MenuLink {
  export type Link = {
    titleKey: TranslationKey;
    href: {
      en: string;
      ja: string;
      "zh-cn": string;
    };
    highlighted?: true;
    nodeType: undefined;
    requiredProductAuthorizations?: Array<keyof UserProductsAuthorizations>;
    hideOnMobile?: boolean;
    hasNewLabel?: boolean;
  };

  export type Divider = {
    nodeType: "divider";
  };

  export type All = Link | Divider;
}

export { menuModel };
